import { TrendingDown } from "lucide-react";

interface PriceComparisonPreviewProps {
  settings: {
    originalPrice?: number;
    currentPrice?: number;
    currency?: string;
    showDiscount?: boolean;
    backgroundColor?: string;
    textColor?: string;
    priceColor?: string;
    oldPriceColor?: string;
    fontSize?: string;
    padding?: string;
    borderRadius?: string;
  };
}

export const PriceComparisonPreview = ({ settings }: PriceComparisonPreviewProps) => {
  const originalPrice = settings.originalPrice || 1000;
  const currentPrice = settings.currentPrice || 500;
  const discountPercentage = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);

  return (
    <div
      className="text-center"
      style={{
        backgroundColor: settings.backgroundColor || "transparent",
        padding: `${settings.padding || 16}px`,
        borderRadius: `${settings.borderRadius || 8}px`,
      }}
    >
      <div className="flex items-center justify-center gap-4 flex-wrap">
        <div className="text-lg line-through opacity-60" style={{ color: settings.oldPriceColor || "#999" }}>
          {originalPrice} {settings.currency || "جنيه"}
        </div>
        <div
          className="text-3xl font-bold"
          style={{
            color: settings.priceColor || "#10b981",
            fontSize: `${settings.fontSize || 32}px`,
          }}
        >
          {currentPrice} {settings.currency || "جنيه"}
        </div>
        {settings.showDiscount && (
          <div className="flex items-center gap-1 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
            <TrendingDown className="h-4 w-4" />
            وفر {discountPercentage}%
          </div>
        )}
      </div>
    </div>
  );
};
